export default function Hero() {
  return (
    <section className="relative bg-plum overflow-hidden pt-16 md:pt-20">
      <div className="relative flex flex-col lg:flex-row min-h-[360px] md:min-h-[500px] max-w-[1280px] mx-auto">
        {/* Texte gauche */}
        <div className="w-full lg:w-[55%] flex flex-col justify-center px-4 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16 relative z-10">
          <p className="font-serif italic text-rose-200 text-sm md:text-base mb-4">
            DF PRO — Réparation de fenêtre
          </p>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
            Réparation de fenêtre à Ostwald
          </h1>
          <p className="md:hidden text-rose-100 text-base leading-relaxed mb-4 max-w-xl">
            Fenêtre qui ferme mal, bloquée, crémone ou poignée cassée à Ostwald ? Réparation à domicile, pièce comprise, devis gratuit.
          </p>
          <p className="hidden md:block text-rose-100 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Ostwald, à moins de dix minutes de Strasbourg, est une commune résidentielle où immeubles et pavillons se côtoient. Les fenêtres y subissent le vent du Rhin et les variations de température. Nos techniciens interviennent rapidement, pièce comprise, sans remplacer toute la menuiserie.
          </p>
          <div className="md:hidden flex flex-wrap gap-x-3 gap-y-1 mb-4 text-rose-100/80 text-xs">
            <span className="whitespace-nowrap">Intervention 24h</span>
            <span className="text-rose-100/40">·</span>
            <span className="whitespace-nowrap">Devis &amp; déplacement gratuits</span>
            <span className="text-rose-100/40">·</span>
            <span className="whitespace-nowrap">Pièce comprise</span>
            <span className="text-rose-100/40">·</span>
            <span className="whitespace-nowrap">Garantie 10 ans</span>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:0374471036"
              className="inline-flex items-center justify-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
            >
              <i className="ri-phone-line" />
              Appeler le 03 74 47 10 36
            </a>
            <a
              href="#devis"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              Devis gratuit
              <i className="ri-arrow-down-line" />
            </a>
          </div>
          <div className="hidden md:flex flex-wrap gap-4 mt-8 text-rose-100 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Intervention 24h
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Devis gratuit
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Toutes marques
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Garantie 10 ans
            </span>
          </div>
        </div>

        {/* Image droite */}
        <div className="w-full lg:w-[45%] relative">
          <div className="absolute inset-0 lg:inset-y-8 lg:right-8 lg:left-0 rounded-none lg:rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/6c02a6462bc9022a96fe598fbac2e1a5.jpeg"
              alt="Réparation de fenêtre à Ostwald, Bas-Rhin"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-plum/80 via-plum/20 to-transparent lg:from-plum/60" />
          </div>
        </div>
      </div>
    </section>
  );
}